import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/contactCenter";
import {
  GetSupervisorContactCenter,
  GetOperadorContactCenter,
  PostContactCenter
} from "../../../reducers/contactCenter";

export interface ConfiguracionContactCenterDispatcher {
  getSupervisorContactCenter: () => Promise<
    Preview<GetSupervisorContactCenter>
  >;
  getOperadorContactCenter: () => Promise<Preview<GetOperadorContactCenter>>;
  postContactCenter: (data: any) => Promise<Preview<PostContactCenter>>;
}

export const configuracionContactCenterDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ConfiguracionContactCenterDispatcher = dispatch => ({
  getSupervisorContactCenter: () => {
    return dispatch(actions.getSupervisorContactCenter());
  },
  getOperadorContactCenter: () => {
    return dispatch(actions.getOperadorContactCenter());
  },
  postContactCenter: (data: any) => {
    return dispatch(actions.postContactCenter(data));
  }
});
